import { discountAgreementActionTypes as actionTypes } from "../../ActionTypes/Voss/discountAgreementActionTypes";

const initialState = {
}
export default function DiscountAgreementsReducer(state = {...initialState}, action) {

    let newState;

    switch (action.type) {
        case actionTypes.STORE_DISCOUNT_AGREEMENTS:
            newState = { discountAgreements: action.data }
            break;
        case actionTypes.STORE_GROUPED_DISCOUNT_AGREEMENTS:
            const sortedData = action.data 
                ? [...action.data].sort((a, b) => a.name.localeCompare(b.name, 'sv'))
                : [];
            newState = { groupedDiscountAgreements: sortedData }
            break;
        case actionTypes.STORE_DISCOUNT_AGREEMENT:
            newState = { discountAgreement: action.data }
            break;
        case actionTypes.STORE_DISCOUNT_AGREEMENT_VERSIONS:
            newState = { discountAgreementVersions: action.data }
            break;
        case actionTypes.STORE_CHARGE_PLAN_DISCOUNTS:
            newState = { chargePlanDiscounts: action.data }
            break;
        default:
            return state;
    }

    return Object.assign({}, state, newState)
}